import { render, staticRenderFns } from "./tabTree.vue?vue&type=template&id=48603666&scoped=true&"
import script from "./tabTree.vue?vue&type=script&lang=js&"
export * from "./tabTree.vue?vue&type=script&lang=js&"
import style0 from "./tabTree.vue?vue&type=style&index=0&id=48603666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48603666",
  null
  
)

export default component.exports